import exceptionHandler from '@advisor/util/exceptionHandler';
import {msalInstance, state, graphScopes} from './msalConfig';

interface RiaUserData {
  username: string;
  preferredUsername: string;
  email: string;
  userId: string;
  enterpriseId: string;
  riaId: string;
  groups: string[];
}

export const login = (): void => {
  // Check if MSAL is initialized before using it has been used
  if (!msalInstance) {
    throw new Error('MSAL not initialized. Call initializeMsal() before using MSAL API.');
  }

  msalInstance
    .handleRedirectPromise()
    .then(() => {
      // Check if user signed in
      const account = msalInstance.getAllAccounts();

      sessionStorage.setItem('ssoBtn', '1');
      if (account.length === 0) {
        // redirect anonymous user to login page
        msalInstance.loginRedirect(graphScopes);
        state.isAuthenticated = true;
        const selectedAccount = msalInstance.getAllAccounts();

        (function (): void {
          msalInstance.setActiveAccount(selectedAccount[0]);
        })();
      } else {
        state.isAuthenticated = msalInstance.getAllAccounts().length > 0;
      }
    })
    .catch((error) => {
      exceptionHandler.handleGenericException('Msal Login error:', error);
    });
};

export const initialize = async (): Promise<void> => {
  try {
    await msalInstance.initialize();
  } catch (error) {
    exceptionHandler.handleGenericException('Msal Initialization error:', error);
  }
};

// eslint-disable-next-line  consistent-return
export const getTokens = async (): Promise<{accessToken: string; idToken: string} | null | undefined> => {
  if (!msalInstance) {
    throw new Error('MSAL not initialized. Call initializeMsal() before using MSAL API.');
  }

  const accounts = msalInstance.getAllAccounts();

  try {
    if (accounts?.length === 0) {
      throw new Error('No accounts found. Please login first.');
    }

    const silentRequest = {
      scopes: [process.env.VUE_APP_API_SCOPES || ''],
      account: accounts[0],
    };
    const silentResponse = await msalInstance.acquireTokenSilent(silentRequest);

    return {accessToken: silentResponse.accessToken, idToken: silentResponse.idToken};
  } catch (error) {
    exceptionHandler.handleGenericException('Silent token acquisition error:', error);
  }
};

export const validateToken = (): boolean => {
  const token = sessionStorage.getItem('token');

  return Boolean(token);
};

export const getAzureToken = (): {accessToken: string; idToken: string} | null => {
  const token = sessionStorage.getItem('token') || '';

  return token ? JSON.parse(token) : null;
};

export const transformRiaUserData = (user): RiaUserData => ({
  username: user?.azureUserId,
  preferredUsername: `${user?.contactInfo?.email1}_${user?.riaId}`,
  email: user?.contactInfo?.email1,
  userId: String(user?.riaUserId || ''),
  enterpriseId: '3',
  riaId: String(user?.riaId || ''),
  groups: ['ria_user'],
});
